import { render, staticRenderFns } from "./mediaCard.vue?vue&type=template&id=3c00a470&scoped=true&"
import script from "./mediaCard.vue?vue&type=script&lang=js&"
export * from "./mediaCard.vue?vue&type=script&lang=js&"
import style0 from "./mediaCard.vue?vue&type=style&index=0&id=3c00a470&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00a470",
  null
  
)

export default component.exports